import React from 'react';
import '../css/footercomponent.css'
import Icon from './iconcomponent';

import terminal1 from '../images/terminal1.png';
import windows from '../images/window.png';

import '../css/cardcomponent.css';

function Footer() {
        const iconNames = [terminal1];

        const iconsData = [
            {
              imageName: iconNames,
              iconLink: '/link1',
              iconName: 'Icon 1',
            },
            {
              imageName: windows,
              iconLink: '/link2',
              iconName: 'Icon 2',
            },
            // Add more icon data objects as needed
          ];

    return (
        <footer className="footer">
                <div className="footer-content">
                    <div className="icon-group">
                        {iconsData.map((iconData, index) => (
                        <Icon
                            key={index}
                            imageName={iconData.imageName}
                            iconLink={iconData.iconLink}
                            // iconName={iconData.iconName}
                        />
                        ))}
                    </div>
                </div>
        </footer>
    );
}

export default Footer;
